<template>
  <div class="sports_rank">
    <div class="myinfo">
      <div class="base">
        <div>
          <div>
            <div v-if="myinfo.organization">{{myinfo.organization}}</div>
            <div>{{myinfo.groupname}}</div>
            
          </div>
          <div class="myrank">
            <template v-if="+myinfo.rank > 0">第 {{ myinfo.rank }} 名</template>
            <template v-else>暂无排名</template>
          </div>
        </div>
        <div>
          <div>{{myinfo.totalscore}}</div>
          <div>团队得分</div>
        </div>
      </div>
      <div class="userlist">
        <div v-for="item in myinfo.userlist" class="u-item" :key="item.urid">
          <div>
            <div><img :src="item.avatarurl" alt=""></div>
            <div>
              <span>{{item.isleader==1?'队长：':'队员：'}}</span>
              <span>{{item.name}}</span>
            </div>
          </div>
          <div>得分：{{item.total_score}}</div>
        </div>
      </div>
    </div>

    <List
      style="color:#FFF;"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getRankList"
    >
      <div class="rank-list">
        <van-collapse v-model="activeNames" v-if="rankList.length">
          <van-collapse-item :name="item.groupid" v-for="item in rankList" :key="item.groupid">
            <template #title>
              <div class="collapse-title">
                <div class="rank_icon">
                  <template v-if="item.rank <= 3">
                    <img src="@/assets/img/rank/first.png" :alt="item.rank" v-if="item.rank == 1" />
                    <img src="@/assets/img/rank/second.png" :alt="item.rank" v-if="item.rank == 2" />
                    <img src="@/assets/img/rank/third.png" :alt="item.rank" v-if="item.rank == 3" />
                  </template>
                  <span v-else>{{ item.rank }}</span>
                </div>
                <div>
                  <div v-if="item.organization">{{item.organization}}</div>
                  <div>{{item.groupname}}</div>                  
                </div>
                
              </div>
            </template>
            <template #value>
              <div class="collapse-value">
                <div>{{item.totalscore}}</div>
                <div>团队得分</div>
              </div>
            </template>
            <div class="clist">
              <div v-for="citem in item.userlist" :key="citem.urid" class="u-item">
                <div>
                  <div><img :src="citem.avatarurl" alt=""></div>
                  <div>
                    <span>{{citem.isleader==1?'队长：':'队员：'}}</span>
                    <span>{{citem.name}}</span>
                  </div>
                </div>
                <div>得分：{{citem.total_score}}</div>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
        <Empty
          style="background: #fff;min-height: 6rem"
          :style="`border-radius: ${borderRadius}`"
          v-else
          description="暂无数据"
        />
      </div>
    </List>
  </div>
</template>

<style lang="less" scoped>
@import "./index.less";

.filter {
  width: 6.9rem;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .item {
    font-size: 0.3rem;
    padding: 0.12rem 0;
    width: 2rem;
    display: flex;
    justify-content: center;
    border-radius: 0.2rem 0.2rem 0 0;

    &.active {
      background: #fff;
      color: #333;
    }
  }
}
</style>

<script>
import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col, Popup,Collapse, CollapseItem } from "vant";

export default {
  computed: {
    buttonColor() {
      let detail = this.detail;
      if (!detail) return "#ccc";
      return `${detail.tabstyle[0]["color"]}`;
    },
    borderRadius() {
      if (this.filter) {
        let i = this.filter.findIndex((row) => {
          return row.active == 1;
        });
        if (i == 0) {
          return "0 .2rem .2rem .2rem";
        } else {
          return ".2rem";
        }
      }
    },
  },
  components: {
    Empty,
    Panel,
    Cell,
    CellGroup,
    List,
    VanImage: Image,
    Row,
    Col,
    Popup,vanCollapse:Collapse, vanCollapseItem:CollapseItem
  },
  props: ["item_sub_id", "sports_id", "item_id"],
  data() {
    return {
      rankList: [],
      loading: false,
      finished: false,
      detail: "",
      page: 1,
      systime: "",
      myinfo: "",
      register_type: "",
      filter: [],
      type: "",
      physical_item_id: 0,
      showVideo: false,
      videoUrl: '',
      animation: 0,
      activeNames: []
    };
  },
  methods: {
    goshow(row){
      this.videoUrl = row.animationurl
      this.showVideo=true
      setTimeout(function(){
        var video = document.querySelector('#video');
        video.play();
      }, 1000);


    },
    onChange(row) {
      if (this.loading) return;
      this.filter.forEach((item) => {
        item.active = 0;
      });
      row.active = 1;
      this.register_type = row.value;
      this.rankList = [];
      this.page = 1;
      this.getRankList();
    },
    getRankList: function () {
      //如果为空or 0 按照 item_id  rank
      this.$api.rank.compareGroupRank({cpgid: this.item_sub_id,type: 3}).then(res=>{
          if(res.status === 200) {
            this.loading = false;          
            this.myinfo = res.data.my
            this.rankList = res.data.list
            let t = null

            this.rankList.forEach((item, index) => {
                if(t == null){
                    t =  item;
                    t.rank = index+1;
                }else{
                    var n = item;
                    if(n.totalscore*1 == t.totalscore*1){
                        n.rank = t.rank;
                    }else{
                          n.rank = index+1;
                    }
                    t = n;
                }
            })
            this.finished = true;
          }
      })
    },
    init: function () {
      this.$toast.loading({
        duration: 0,
      });
      let params = { cpgid: this.item_sub_id };
      this.$api.sports.sportsMain(this.sports_id).then((res) => {
        let { bgstyle, id, tabstyle, introstyle, title } = res.data;
        try {
          bgstyle = JSON.parse(bgstyle);
          tabstyle = JSON.parse(tabstyle);
          introstyle = JSON.parse(introstyle);
        } catch (e) {
          console.error(e);
        }
        this.detail = { id, bgstyle, tabstyle, introstyle, title };
        this.$toast.clear();
      });

      if (!+this.item_sub_id) {
        this.$api.sports
          .getMySportsItemRank({ id: this.item_id })
          .then((res) => {
            this.myinfo = res.data;
          });
      }
    },
  },
  mounted() {
    this.init();
    // this.getRankList();
  },
};
</script>
